import React from "react";
import { useDateModalContext } from "./DateModalContext";

const EmptyDateTimeButton: React.FC = () => {
  const { handleAddDateTime } = useDateModalContext();

  return (
    <button
      className="box-border flex h-[30px] flex-1 items-center rounded-[5px] px-1 text-sm font-normal leading-[30px] text-[#7c7d7d] hover:rounded-[5px] hover:bg-w-8-hover"
      onClick={handleAddDateTime}
    >
      <span>Add Date/Time</span>
    </button>
  );
};

export default EmptyDateTimeButton;
